module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-de-DE.49f837ff.jpg";